import {
  fetchAuthSession,
  fetchUserAttributes,
  getCurrentUser,
} from 'aws-amplify/auth';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

export const CognitoHostedUIIdentityProvider = {
  Cognito: 'COGNITO',
  Google: 'Google',
  Facebook: 'Facebook',
  Amazon: 'Amazon',
  Apple: 'Apple',
};

function attributesArrayToObject(attributes) {
  if (!attributes) return {};
  if (!Array.isArray(attributes) && typeof attributes === 'object') {
    return { ...attributes };
  }
  if (Array.isArray(attributes)) {
    return attributes.reduce((acc, attribute) => {
      if (attribute?.name) acc[attribute.name] = attribute.value;
      return acc;
    }, {});
  }
  return {};
}

export function setAuthStorage(storage) {
  if (storage) {
    cognitoUserPoolsTokenProvider.setKeyValueStorage(storage);
  }
}

export async function getAuthSession(forceRefresh = false) {
  return fetchAuthSession(forceRefresh ? { forceRefresh: true } : undefined);
}

export async function getIdToken(forceRefresh = false) {
  const session = await getAuthSession(forceRefresh);
  return session.tokens?.idToken?.toString();
}

export async function getAccessToken(forceRefresh = false) {
  const session = await getAuthSession(forceRefresh);
  return session.tokens?.accessToken?.toString();
}

export async function getAuthHeaders(additionalHeaders = {}, { forceRefresh = false } = {}) {
  const token = await getIdToken(forceRefresh);
  if (!token) {
    throw new Error('Missing authentication token');
  }
  return {
    ...additionalHeaders,
    Authorization: token,
  };
}

export async function getAuthenticatedUser({ forceRefresh = false } = {}) {
  const [session, user, attributes] = await Promise.all([
    getAuthSession(forceRefresh),
    getCurrentUser(),
    fetchUserAttributes(),
  ]);
  const attributesObject = attributesArrayToObject(attributes);
  return {
    ...user,
    attributes: attributesObject,
    tokens: session.tokens || null,
  };
}

export async function getUserAttributes() {
  const attributes = await fetchUserAttributes();
  return attributesArrayToObject(attributes);
}
